import { IAiReplaceSlidePCService } from '@src/slide/application/service/ai-replace-slide/ai-replace-slide-service.interface';
import { IAIAssistantService } from '@src/slide/application/service/ai-ssistant/ai-ssistant-service.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IDynamicServiceConfig } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

type ReturnType = IDynamicServiceConfig<IAiReplaceSlidePCService>;

export const pcAIReplaceSlideConfig = (
    uiDataService: IUiDataService,
    selectionService: ISelectionService,
    aiAssistantService: IAIAssistantService,
): ReturnType => ({
    name: 'ai-replace-slide-service',
    loadType: 'on-demand',
    async module() {
        const { AiReplaceSlideServicePC } = await import('@src/slide/application/service/ai-replace-slide/ai-replace-slide-service-pc');
        return new AiReplaceSlideServicePC(uiDataService, selectionService, aiAssistantService);
    },
});
